<script lang="ts">
import { type Component, defineComponent } from 'vue';
import { ToggleSwitch } from 'primevue';
import { mapActions, mapState } from 'pinia';
import { useAppStore } from '@/stores/app';

export default defineComponent({
  name: 'aside-menu',
  components: { ToggleSwitch },
  computed: {
    ...mapState(useAppStore, ['userName']),
  },
  data() {
    return {
      isVisible: true,
      isDarkMode: true,
    };
  },
  methods: {
    ...mapActions(useAppStore, ['setToken']),
    logout() {
      this.setToken(null);
      this.$router.push('/');
    },
  },
  props: ['items'],
  watch: {
    isDarkMode(n) {
      if (n) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
  }
}) as Component;
</script>

<template>
  <Drawer v-model:visible="isVisible" :show-close-icon="false" :dismissable="false" :modal="false">
    <template #closeicon>
      <i class="pi pi-ellipsis-v"></i>
    </template>
    <template #header>
      <div class="flex">
        <div class="font-thin ml-4 text-2xl">Sport.Admin</div>
      </div>
    </template>
    <Menu :model="items">
      <template #item="{ item, props }">
        <router-link
          v-if="item.route"
          v-slot="{ href, navigate }"
          :to="item.route"
          custom
        >
          <a :href="href" v-bind="props.action" @click="navigate" class="ml-3">
            <span :class="item.icon" />
            <span class="ml-1">{{ item.label }}</span>
          </a>
        </router-link>
        <a v-else :href="item.url" :target="item.target" v-bind="props.action" class="ml-3">
          <span :class="item.icon" />
          <span class="ml-1">{{ item.label }}</span>
        </a>
      </template>
      <template #end>
        <div class="border border-t-0 border-bottom border-gray-700 dark:border-gray-300 border-dotted opacity-50 my-4" />
      </template>
    </Menu>
    <div class="flex ml-6">
      <label class="flex-1">
        <i class="pi pi-sparkles" size="lg" />
        <span class="ml-2"> Тёмная тема </span>
      </label>
      <ToggleSwitch v-model="isDarkMode"/>
    </div>
    <div class="flex ml-6 mt-4">
      <Button @click="logout">
        <i class="pi pi-sign-out text-red-500" size="lg" />
        <span class="ml-2"> Выход [{{ userName }}]</span>
      </Button>
    </div>
  </Drawer>
</template>
